/** Limits of the bulk import (story/prototype; the backend contract is pending ARP-1480). */
export const MAX_ROWS = 1000;
export const MAX_BYTES = 5 * 1024 * 1024;
export const ACCEPTED_EXTENSIONS = Object.freeze(['.xlsx', '.csv']);
/** `accept` value for the file picker. */
export const ACCEPT_ATTRIBUTE = ACCEPTED_EXTENSIONS.join(',');

/** Typed reasons a file is rejected, shared by the parser and the upload step. */
export const IMPORT_ERROR = Object.freeze({
  UNSUPPORTED_TYPE: 'unsupported_type',
  TOO_LARGE: 'too_large',
  TOO_MANY_ROWS: 'too_many_rows',
  EMPTY: 'empty',
  UNREADABLE: 'unreadable',
  MULTIPLE: 'multiple',
});
